import { render, staticRenderFns } from "./bigimg.vue?vue&type=template&id=46aa7f86&scoped=true&"
import script from "./bigimg.vue?vue&type=script&lang=js&"
export * from "./bigimg.vue?vue&type=script&lang=js&"
import style0 from "./bigimg.vue?vue&type=style&index=0&id=46aa7f86&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aa7f86",
  null
  
)

export default component.exports